import { Helmet } from "react-helmet-async";

const PageSeo = ({
  title,
  description,
  keywords,
  ogImage,
  ogType = "website",
  canonical,
  robots = "index,follow",
  twitterHandle,
  siteName = "Pikko Dubai",
  structuredProduct,
}) => {
  const resolvedTitle = title || siteName;
  const resolvedDesc = description || "";
  const resolvedUrl =
    canonical ||
    (typeof window !== "undefined" ? window.location.href : "");

  const productSchema =
    structuredProduct
      ? {
          "@context": "https://schema.org",
          "@type": "Product",
          name: structuredProduct.name,
          description: structuredProduct.description,
          image: structuredProduct.image,
          sku: structuredProduct.sku,
          ...(structuredProduct.brand && {
            brand: { "@type": "Brand", name: structuredProduct.brand },
          }),
          offers: {
            "@type": "Offer",
            price: structuredProduct.price,
            priceCurrency: structuredProduct.currency || "AED",
            availability: `https://schema.org/${structuredProduct.availability || "InStock"}`,
            url: structuredProduct.url || resolvedUrl,
          },
        }
      : null;

  return (
    <Helmet>
      {/* ── Basic ── */}
      <title>{resolvedTitle}</title>
      {resolvedDesc && <meta name="description" content={resolvedDesc} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      {resolvedUrl && <link rel="canonical" href={resolvedUrl} />}

      {/* ── Open Graph ── */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={resolvedTitle} />
      {resolvedDesc && (
        <meta property="og:description" content={resolvedDesc} />
      )}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={resolvedUrl} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:alt" content={resolvedTitle} />}
      {ogImage && <meta property="og:image:width" content="1200" />}
      {ogImage && <meta property="og:image:height" content="630" />}

      {/* ── Twitter Card ── */}
      <meta
        name="twitter:card"
        content={ogImage ? "summary_large_image" : "summary"}
      />
      <meta name="twitter:title" content={resolvedTitle} />
      {resolvedDesc && (
        <meta name="twitter:description" content={resolvedDesc} />
      )}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {twitterHandle && (
        <meta name="twitter:site" content={twitterHandle} />
      )}

      {/* ── Product JSON-LD (product pages only) ── */}
      {productSchema && (
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default PageSeo;
